var map = {
	"./de/state": 238,
	"./en/state": 239
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;


//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/.*\/state$
// module id = 410
// module chunks = 2